import { BadgeCheck } from "lucide-react";

export const RefCode = ({ code, testId }) => code ? (
  <span className="inline-flex items-center gap-1 text-[11px] font-mono font-semibold text-slate-600 bg-slate-50 border border-slate-200 rounded-md px-1.5 py-0.5" dir="ltr" data-testid={testId}>
    <BadgeCheck size={12} className="text-sun" />{code}
  </span>
) : null;
